import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.scss'],
    standalone: false
})
export class ResetComponent implements OnInit {

    public hash: string | null = '';
    public loading: boolean = false;
    public reset: boolean | null = false;
    public error = 0;
    public resetForm: UntypedFormGroup;
    public inputType = 'password';
    constructor(
        protected formBuilder: UntypedFormBuilder,
        protected router: Router,
        protected authService: AuthService,
        protected route: ActivatedRoute,
    ) {
        this.hash = this.route.snapshot.paramMap.get('hash');
    }

    ngOnInit(): void {
        this.resetForm = this.formBuilder.group({
            password: [null, Validators.required],
            passwordConfirm: [null, Validators.required]
        });
    }

    public resetAction(): void {
        if (!this.hash) {
            return;
        }

        this.error = 0;
        this.reset = false;
        const values = this.resetForm.getRawValue();
        if (values.password != values.passwordConfirm) {
            this.error = 1;
            return;
        }

        this.loading = true;
        this.authService.reset(values.password, this.hash).subscribe(
            reset => {
                if (!reset) {
                    this.error = 2;
                }
                this.loading = false;
                this.reset = reset;
            }
        )
    }

    public toggleShowPassword(): void {
        if (this.inputType == 'password') {
            this.inputType = 'text';
        } else {
            this.inputType = 'password';
        }
    }
}
